const CommonAnalyticsBroker = require('./common-analytics-broker');
module.exports = new CommonAnalyticsBroker();




// WEBPACK FOOTER //
// ./~/@atlassiansox/experiment-common-core/lib/common-analytics-singleton.js